// @ts-nocheck
import React from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";


import useOneOnOneMessagingEvents from "../socketEvents/oneOnOneMessaging/useOneOnOneMessagingEvents";
import {
  fetchOneOnOneChatRoomsForAdmin,
  fetchOneOnOneChatRoomsForClient
} from "../../store/actions/oneOnOneMessagingActions";
import { USER_ROLES } from "../../staticData/userRoles";
import { isUserRole } from "../../utils/methods/storeFunc";

const useOneOnOneMessaging = () => {
  // state variables start...
  const [isRenderedOnce, setIsRenderedOnce] = React.useState(false);
  // state variables end...

  // redux hooks start...
  const dispatch = useDispatch();
  const auth = useSelector((store) => store.auth);
  // redux hooks end...

  // react-router hooks start...
  const location = useLocation();
  // react-router hooks end...

  // custom hooks start...
  useOneOnOneMessagingEvents({
    global: true
  });
  // custom hooks end...

  // useEffect start...
  React.useEffect(() => {
    if (location.pathname === "/event/chat/admin") {
      return;
    }

    if (!isRenderedOnce) {
      if (isUserRole(USER_ROLES.ADMIN, USER_ROLES.SUPERADMIN)) {
        dispatch(fetchOneOnOneChatRoomsForAdmin({}));
      } else {
        dispatch(fetchOneOnOneChatRoomsForClient({}));
      }
      setIsRenderedOnce(true);
    }
  }, [location, isRenderedOnce]);

  // React.useEffect(() => {
  //   dispatch(
  //     fetchUnreadMsgChatRoomsCountAction()
  //   )
  // }, []);
  // useEffect end...
};

export default useOneOnOneMessaging;